import {Suspense, useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {RittAppProvider} from './utils/contextProvider/RittAppProvider'
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3'
import {app_id} from './modules/config'
import {UserStateProvider} from './utils/contextProvider/UserStateProvider'
import SetupTokenExpireNavigate from './utils/components/SetupTokenExpireNavigate'

export const siteKey = '90ce2c00-a3ce-487a-87c4-c4100ea61932'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        {/* <GoogleReCaptchaProvider reCaptchaKey={siteKey}> */}
        <LayoutProvider>
          <AuthInit>
            <SetupTokenExpireNavigate />
            <UserStateProvider>
              <RittAppProvider>
                <Outlet />
                <MasterInit />
              </RittAppProvider>
            </UserStateProvider>
          </AuthInit>
        </LayoutProvider>
        {/* </GoogleReCaptchaProvider> */}
      </I18nProvider>
    </Suspense>
  )
}

export {App}
